<template>
	<vs-table
		v-if="optimizationList.length > 0"
		v-model="selected"
		class="mb-base"
		search
		pagination
		:max-items="itemsPerPage"
		:data="optimizationList"
	>
		<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
			<div class="flex flex-wrap-reverse items-center data-list-btn-container">
				<!-- ACTION - DROPDOWN -->
				<vs-button
					icon-pack="feather"
					icon="icon-arrow-left"
					@click="$emit('closeOptimizationDetail', false)"
					>{{ $t("Back") }}</vs-button
				>
			</div>
		</div>
		<template slot="thead">
			<vs-th>ID</vs-th>
			<vs-th>{{ $t("Routing.Table.Name") }}</vs-th>
			<vs-th>{{ $t("RoutingType.RoutingType") }}</vs-th>
			<vs-th>{{ $t("Routing.Table.AddedOn") }}</vs-th>
		</template>
		<template slot-scope="{data}">
			<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
				<vs-td :data="data[indextr].id">
					{{ data[indextr].id }}
				</vs-td>
				<vs-td :data="data[indextr].name">
					{{ data[indextr].name }}
				</vs-td>
				<vs-td :data="data[indextr].routing_api">
					<span class="flex items-center px-2 py-1 rounded"
						><div
							class="h-3 w-3 rounded-full mr-2"
							:style="{
								backgroundColor:
									data[indextr].routing_api === 'GMPRO'
										? '#3D79B8'
										: data[indextr].routing_api === 'OPENROUTE'
										? '#b5152b'
										: data[indextr].routing_api === 'TOUR_PLANNING'
										? '#30b59a'
										: '',
							}"
						></div>
						{{ data[indextr].routing_api }}</span
					>
				</vs-td>
				<vs-td :data="data[indextr].added_on">
					{{ data[indextr].added_on }}
				</vs-td>
			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
export default {
	props: {
		optimizationList: {
			type: Array,
			default: [],
			required: true,
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 4,
		};
	},
};
</script>
